import Vue from 'vue'
import Options from '~/utils/options'
import Helper from '~/utils/helper'
import ObjectHelper from '~/utils/object'

Vue.use(Options)
Vue.use(Helper)
Vue.use(ObjectHelper)


// WEBPACK FOOTER //
// ./plugins/utils.js